import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import MainLayout from '@/layouts/MainLayout.vue'
import LoongLayout from '@/layouts/LoongLayout.vue'

Vue.use(Router)

const routes = [
  {
    path: '/',
    component: MainLayout,
    children: [
      {
        path: '/',
        redirect: '/home',
      },
      {
        path: '/home',
        name: 'home',
        component: Home
      },
      {
        path: '/research',
        name: 'research',
        // 修改懒加载的写法
        component: () => import('@/views/Research.vue')
      },
      {
        path: '/more',
        name: 'more',
        component: () => import('@/views/More.vue')
      },
      {
        path: '/publication',
        name: 'publication',
        component: () => import('@/views/Publication.vue')
      },
      {
        path: '/awards',
        name: 'awards',
        component: () => import('@/views/Awards.vue')
      },
      {
        path: '/services',
        name: 'services',
        component: () => import('@/views/Services.vue')
      },
      {
        path: '/teaching',
        name: 'teaching',
        component: () => import('@/views/Teaching.vue')
      },
      {
        path: '/students',
        name: 'students',
        component: () => import('@/views/Students.vue')
      }
    ]
  },
  {
    path: '/loong',
    component: LoongLayout,
    children: [     
      {
        path: '',  // 修改路径
        redirect: 'home',  // 修改重定向路径
      },
      {
        path: 'home',  // 修改路径，移除前面的 /loong/
        name: 'loong_home',
        component: () => import('@/views/Loong/Home.vue')
      },
      {
        path: 'demo',  // 修改路径
        name: 'loong_demo',
        component: () => import('@/views/Loong/Demo.vue')
      },
      {
        path: 'publications',  // 修改路径
        name: 'loong_publications',
        component: () => import('@/views/Loong/Publications.vue')
      },
      {
        path: 'news',  // 修改路径
        name: 'loong_news',
        component: () => import('@/views/Loong/News.vue')
      },
      {
        path: 'group',  // 修改路径
        name: 'loong_group',
        component: () => import('@/views/Loong/Group.vue')
      }
    ]
  }
]

// 创建路由实例
const router = new Router({
  mode: 'hash',
  routes: routes
})

// 辅助函数：更改网页图标
function setFavicon(iconName) {
  let link = document.querySelector("link[rel~='icon']")
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.head.appendChild(link)
  }
  link.href = `/${iconName}`
}

// 添加全局路由守卫
router.beforeEach((to, from, next) => {
  const viewport = document.querySelector('meta[name=viewport]')
  if (to.path.startsWith('/loong')) {
    document.title = 'Project Loong'
    setFavicon('loong.png')
    viewport.setAttribute('content', 
      'width=1600, initial-scale=1.0, maximum-scale=5.0, minimum-scale=0.1, user-scalable=yes'
    )
  } else {
    document.title = 'Qunbi Zhuge'
    setFavicon('sjtu.png')
    viewport.setAttribute('content', 
      'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
    )
  }
  next()
})
router.afterEach((to, from, next) => {
  const viewport = document.querySelector('meta[name=viewport]')
  if (to.path.startsWith('/loong')) {
    viewport.setAttribute('content', 
      'width=1600, initial-scale=1.0, maximum-scale=5.0, minimum-scale=0.1, user-scalable=yes'
    )
  } else {
    viewport.setAttribute('content', 
      'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
    )
  }
})
export default router